export default {
  val_email: 'Invalid format',
  val_phone: 'Minimum of 9 digits',
  val_dni: 'Minimum of 8 characters',
  val_user_verification: 'Minimum 8 characters, 1 capital letter, 1 number and 1 special character .',
  val_empty: 'Cannot be empty',
  val_clinic: 'You must choose a clinic',
  val_empty_data: 'No representative data',
};
